import { useFlightFiltersContext } from "@/app/lib/context/FlightFiltersContext";
import {
  useFlightSelectionPayloadContext,
  type FlightType,
  type FullOfferType,
} from "@/app/lib/context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import { useReturnFlightSearch } from "@/app/lib/hooks/flightSearch/useReturnFlightSearch";
import {
  useFlightQuickSearchTokens,
  useFlightSearchTokens,
} from "@/app/lib/hooks/useFlightSearchTokens";
import { FlightsList } from "@/app/ui/flight-list/FlightsList";
import { SelectedDepartureFlightDrawer } from "@/app/ui/flight-list/SelectedDepartureFlightDrawer";
import { WhatsAppButton } from "@/app/ui/WhatsAppButton";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

export const Route = createFileRoute(
  "/_authenticated/_flights/flights/return/list",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { history } = useRouter();
  const t = useTranslations();

  const {
    handleReturnFlightSelection,
    selectedOfferIndex,
    selectedDepartureFlightId,
    selectedFlightSearchSource,
  } = useFlightSelectionPayloadContext();
  const flightSearch = useFlightSearchTokens({
    enabled: selectedFlightSearchSource === "full",
  });
  const quickTokensQuery = useFlightQuickSearchTokens();
  const { filters } = useFlightFiltersContext();
  const searchQuery = useReturnFlightSearch(
    selectedFlightSearchSource === "quick"
      ? quickTokensQuery
      : flightSearch.query,
    filters,
    selectedOfferIndex,
    selectedDepartureFlightId,
  );

  const handleFlightSelect = (offer: FullOfferType, flight: FlightType) => {
    handleReturnFlightSelection(offer, flight.key);
    navigate({
      to: "/flights/offer/$id/step/1",
      params: { id: offer.index },
    });
  };

  return (
    <main className="no-footer main h-screen pb-[calc(var(--spacing)*2+var(--departure-flight-drawer-height,0))]">
      <FlightsList
        onFlightSelect={handleFlightSelect}
        direction="return"
        searchQuery={{ query: searchQuery, type: selectedFlightSearchSource }}
        title={<div>{t("flights.chooseReturnFlight")}</div>}
        // when user triggers new search he has to select departure flight again so we need to navigate back to departure flights list
        onAfterSearchSubmit={() => history.back()}
      />
      <SelectedDepartureFlightDrawer />
      <WhatsAppButton
        bottomPosition={
          "calc(var(--departure-flight-drawer-height) + calc(var(--spacing)*4))"
        }
      />
    </main>
  );
}
